import { render, staticRenderFns } from "./RsaGestioneOspitiViewComponent.vue?vue&type=template&id=0eb39f5c"
import script from "./RsaGestioneOspitiViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports